import { dmaCalculationResultDtoSchema } from "@fonterra/dma-api-schema";
import { z } from "zod";
import { npdCalculationResultDtoSchema } from "./npd-calculation-result.schema";
export const npdCalculationResultsDtoSchema = z.object({
    results: z.array(npdCalculationResultDtoSchema),
    rawResults: z.array(dmaCalculationResultDtoSchema),
});
